/**
 * Low-key progress strip at the bottom of the deck stage.
 */
export function DeckProgressBar({ idx, total }) {
  return (
    <div className="absolute bottom-0 left-0 right-0 z-20 px-6 pb-3 pointer-events-none">
      <div className="h-0.5 w-full bg-ink-900/10 rounded-full overflow-hidden">
        <div
          className="h-full bg-sun-500 transition-all duration-300"
          style={{ width: `${((idx + 1) / total) * 100}%` }}
          data-testid="progress-bar"
        />
      </div>
      <div className="mt-1.5 flex justify-end mono text-[9px] uppercase tracking-[0.22em] text-ink-900/45">
        {String(idx + 1).padStart(2, "0")} / {String(total).padStart(2, "0")}
      </div>
    </div>
  );
}
